import MainLayout from "../../components/layout/MainLayout/MainLayout";

import HomeHero from "../../components/Home/HomeHero";
import StatsBar from "../../components/Home/StatsBar";
import ServicesPreview from "../../components/Home/ServicesPreview";
import FeaturedProjects from "../../components/Home/FeaturedProjects";
import AwardsSection from "../../components/Home/AwardsSection";
import ClientLogos from "../../components/Home/ClientLogos";
import HomePartnerInquiry from "../../components/Home/HomePartnerInquiry";
import HomeCTA from "../../components/Home/HomeCTA";
import WhyChooseSAC from "../../components/Home/WhyChooseSAC";
import HomeSACDifference from "../../components/Home/HomeSACDifference";
import HomeGlobalPresence from "../../components/Home/HomeGlobalPresence";

export default function Home() {
  return (
    <MainLayout noTopPadding>
      <HomeHero />

      <div className="bg-gradient-to-b from-transparent to-white">
        <StatsBar />
      </div>

      <WhyChooseSAC />
      <ServicesPreview />
      <HomeSACDifference />
      <FeaturedProjects />
      <HomeGlobalPresence />
      <AwardsSection />
    
      <ClientLogos />
      <HomeCTA />
      <HomePartnerInquiry />
    </MainLayout>
  );
}
